/**
 * El tracking de actividad de carrito ("Producto añadido al carrito", etc.) lo
 * hace el propio App Embed automático de Connectif — no lo duplicamos aquí.
 * Probamos a notificar también el estado del carrito con
 * connectif.managed.sendEvents en cada "cart:change" para que el bloque de
 * crosselling reaccionara a las eliminaciones, pero esa llamada también
 * genera su propia actividad de "Producto añadido al carrito" en su panel,
 * sumándose a los duplicados que ya produce su tracking automático. Hasta que
 * Connectif aclare cómo actualizar el contexto del carrito sin generar
 * actividad duplicada, no la usamos.
 *
 * Este script se limita a la parte que Connectif no puede resolver por sí
 * mismo dentro de nuestro tema: mantener estable el contenedor donde insertan
 * su inline de crosselling, evitar que se acumulen varias inserciones, y el
 * intercept del botón de su widget.
 */
(function () {
  /**
   * #crosselling-carrito vive en layout/theme.liquid: es un único nodo permanente,
   * presente desde la carga inicial de cualquier página, para que Connectif pueda
   * localizarlo y trabajar sobre él sin depender del cart drawer.
   *
   * El cart drawer (assets/theme.js, componente <cart-drawer>) reconstruye TODO su
   * contenido interno con `replaceChildren` cada vez que cambia el carrito. Por eso
   * no colocamos el nodo dentro del drawer: en su lugar, colocamos ahí un simple
   * punto de anclaje (#crosselling-carrito-anchor) y MOVEMOS (nunca clonamos ni
   * recreamos) el nodo real dentro de él cuando el drawer necesita mostrarlo.
   *
   * Guardamos la referencia al nodo UNA SOLA VEZ aquí y la reutilizamos siempre,
   * en vez de volver a buscarlo por id cada vez: `theme.js` puede disparar
   * "dialog:before-show" antes de terminar de reconstruir el contenido del
   * drawer (onCartChange_fn llama a replaceContent_fn sin esperarla y acto
   * seguido a this.show()), así que el nodo puede quedar momentáneamente
   * "atrapado" dentro de un anchor que luego se destruye. Si lo buscásemos con
   * document.getElementById en ese instante ya no lo encontraríamos (deja de
   * estar en el documento) y se perdería para siempre.
   */
  var crossellingSlot = document.getElementById("crosselling-carrito");
  var crossellingHome = document.body;

  function mountCrossellingSlot() {
    var anchor = document.querySelector("#cart-drawer #crosselling-carrito-anchor");

    if (!crossellingSlot || !anchor || anchor.contains(crossellingSlot)) {
      return;
    }

    anchor.appendChild(crossellingSlot);
    crossellingSlot.hidden = false;
  }

  function unmountCrossellingSlot() {
    if (!crossellingSlot || crossellingSlot.parentElement === crossellingHome) {
      return;
    }

    crossellingSlot.hidden = true;
    crossellingHome.appendChild(crossellingSlot);
  }

  /**
   * Connectif inserta su inline "en el interior" del contenedor (añade, no
   * reemplaza). Si dos inserciones llegan por separado para el mismo cambio de
   * carrito (p. ej. su tracking automático y nuestro aviso manual, cada uno
   * disparando su propia recomendación con una pequeña diferencia de tiempo),
   * se apilan una encima de otra. Para evitarlo, cada vez que se añaden nodos
   * nuevos al contenedor, eliminamos automáticamente todo lo que hubiera antes
   * de esa inserción — así el contenedor nunca muestra más que la última
   * recomendación recibida, venga de donde venga.
   */
  if (crossellingSlot && window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length === 0) {
          return;
        }

        Array.prototype.forEach.call(crossellingSlot.childNodes, function (node) {
          if (!Array.prototype.includes.call(mutation.addedNodes, node)) {
            node.remove();
          }
        });
      });
    }).observe(crossellingSlot, { childList: true });
  }

  var cartDrawerEl = document.getElementById("cart-drawer");

  if (cartDrawerEl) {
    // El drawer puede reconstruir su contenido (nuevo #crosselling-carrito-anchor)
    // mientras está abierto (p. ej. al cambiar la cantidad de un producto): hay
    // que volver a montar el nodo real en el anchor nuevo.
    cartDrawerEl.addEventListener("cart-drawer:refreshed", mountCrossellingSlot);
    cartDrawerEl.addEventListener("dialog:before-show", mountCrossellingSlot);
    // Al cerrar el drawer devolvemos el nodo a su sitio permanente para que
    // un `cart:change` con el drawer cerrado no lo destruya junto al resto
    // del contenido del drawer.
    cartDrawerEl.addEventListener("dialog:after-hide", unmountCrossellingSlot);

    if (cartDrawerEl.hasAttribute("open")) {
      mountCrossellingSlot();
    }
  }

  /**
   * La regla de Connectif solo debe mostrar este bloque cuando el carrito
   * tiene exactamente 1 producto distinto (sea cual sea su cantidad). Como el
   * nodo #crosselling-carrito ya no se destruye nunca, si Connectif no llega a
   * limpiar su contenido a tiempo cuando esa condición deja de cumplirse (p.
   * ej. el carrito se vacía, o se añade un segundo producto distinto), el
   * bloque se quedaría mostrando el inline antiguo indefinidamente. Por eso lo
   * vaciamos nosotros mismos en cuanto detectamos que la condición ya no se
   * cumple.
   *
   * NOTA: esto no cubre el caso de volver a cumplir la condición al ELIMINAR
   * un producto (p. ej. pasar de 2 a 1) sin que Connectif se entere y decida
   * reinsertar — su tracking automático solo parece reaccionar a añadidos.
   * Pendiente de que Connectif confirme cómo notificarles ese caso sin generar
   * actividad duplicada de "Producto añadido al carrito".
   */
  document.addEventListener("cart:change", function (event) {
    var cart = event.detail && event.detail.cart;

    if (!crossellingSlot || !cart || !cart.items) {
      return;
    }

    if (cart.items.length !== 1 && crossellingSlot.innerHTML.trim() !== "") {
      crossellingSlot.innerHTML = "";
    }
  });

  /**
   * El botón "Ver"/"Añadir al carrito" del inline de Connectif enlaza a la
   * ficha de producto en vez de añadir directamente al carrito. Su plantilla
   * no se puede editar desde el tema, pero el enlace ya incluye el ID de la
   * variante en la URL (?variant=123456...), así que lo extraemos e
   * interceptamos el clic para hacer el add-to-cart nosotros mismos.
   */
  function addVariantToCart(variantId) {
    return fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (response) {
      if (response.ok) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
      return response;
    });
  }

  document.addEventListener("click", function (event) {
    if (!crossellingSlot) {
      return;
    }
    var link = event.target.closest("a[class*='_button'][href*='variant=']");
    if (!link || !crossellingSlot.contains(link)) {
      return;
    }
    var match = link.href.match(/variant=(\d+)/);
    if (!match) {
      return;
    }
    event.preventDefault();
    addVariantToCart(match[1]);
  });
})();
